"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8600],{

/***/ 56146:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": function() { return /* binding */ MarkAsReadAlternativeOutlined; }
/* harmony export */ });
/* harmony import */ var _helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32600);


const MarkAsReadAlternativeOutlined = (props) => {
  return (0,_helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w_)({
    tag: "svg",
    attr: { viewBox: "0 0 24 24", fill: "none" },
    child: [
      {
        tag: "path",
        attr: {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M2.25 5.5C2.25 5.08579 2.58579 4.75 3 4.75H21C21.4142 4.75 21.75 5.08579 21.75 5.5C21.75 5.91421 21.4142 6.25 21 6.25H3C2.58579 6.25 2.25 5.91421 2.25 5.5ZM21.0658 13.2625C21.3587 13.5553 21.3587 14.0302 21.0658 14.3231L16.8232 18.5658C16.5303 18.8586 16.0554 18.8586 15.7625 18.5658L12.9341 15.7373C12.6412 15.4444 12.6412 14.9696 12.9341 14.6767C13.227 14.3838 13.7019 14.3838 13.9948 14.6767L16.2929 16.9748L20.0052 13.2625C20.2981 12.9696 20.773 12.9696 21.0658 13.2625ZM3 8.75C2.58579 8.75 2.25 9.08579 2.25 9.5C2.25 9.91421 2.58579 10.25 3 10.25H21C21.4142 10.25 21.75 9.91421 21.75 9.5C21.75 9.08579 21.4142 8.75 21 8.75H3ZM2.25 13.5C2.25 13.0858 2.58579 12.75 3 12.75H8C8.41421 12.75 8.75 13.0858 8.75 13.5C8.75 13.9142 8.41421 14.25 8 14.25H3C2.58579 14.25 2.25 13.9142 2.25 13.5ZM3 16.75C2.58579 16.75 2.25 17.0858 2.25 17.5C2.25 17.9142 2.58579 18.25 3 18.25H8C8.41421 18.25 8.75 17.9142 8.75 17.5C8.75 17.0858 8.41421 16.75 8 16.75H3Z",
          fill: "#82869E"
        }
      }
    ]
  })(props);
};




/***/ }),

/***/ 18600:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "MiniNotification": function() { return /* binding */ MiniNotification; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(61261);
/* harmony import */ var i18n__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(34655);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(91987);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(35874);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(35304);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _desktop_organisms_MiniNotificationItem__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(44304);
/* harmony import */ var contexts__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(18110);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(21483);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(88123);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(36344);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(71323);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(57572);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(98640);
/* harmony import */ var _teko_ds_icon__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(56146);
/* harmony import */ var _teko_tracking__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(28247);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    const data = _taggedTemplateLiteral([
        "\n  background-color: #fff;\n  border-radius: 8px;\n  box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.15);\n  width: 384px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = _taggedTemplateLiteral([
        "\n  a {\n    color: #a7abc3;\n    text-decoration: none;\n    &:hover {\n      color: #82869e;\n    }\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = _taggedTemplateLiteral([
        "\n  line-height: 24px;\n  padding: 10px 16px;\n  background-color: #f8f8fc;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}











const Wrapper = (0,_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_5__/* .Shape */ .b)(_templateObject());
const LastLinkWrapper = (0,_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_6__/* .Flex */ .k)(_templateObject1());
const WrapperHeader = (0,_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_6__/* .Flex */ .k)(_templateObject2());
const NotificationHeader = (props)=>{
    const { title , markReadAll , loading  } = props;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(WrapperHeader, {
        justify: "space-between",
        align: "center",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_7__/* .Body */ .uT, {
                color: "extSecondary",
                weight: "regular",
                children: title
            }),
            markReadAll && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_8__/* .Tooltip */ .u, {
                title: (0,i18n__WEBPACK_IMPORTED_MODULE_9__.t)("Đ\xe1nh dấu tất cả đ\xe3 đọc"),
                placement: "bottom",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_10__/* .ButtonIcon */ .E, {
                    onClick: markReadAll,
                    loading: loading,
                    size: 24,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_icon__WEBPACK_IMPORTED_MODULE_11__/* .MarkAsReadAlternativeOutlined */ .X, {})
                })
            })
        ]
    });
};
const MiniNotification = (param)=>{
    let { onHide  } = param;
    const { notifications , handleNotificationClicked , loading , status , markReadAll , markAllReadLoading ,  } = (0,contexts__WEBPACK_IMPORTED_MODULE_12__/* .useNotification */ .lm)();
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)();
    if (status === contexts__WEBPACK_IMPORTED_MODULE_12__/* .PageStatus.EMPTY */ .ti.EMPTY && !loading && false) {}
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(Wrapper, {
        backgroundColor: "white",
        borderRadius: "l",
        children: [
            !!notifications.length && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(NotificationHeader, {
                        title: (0,i18n__WEBPACK_IMPORTED_MODULE_9__.t)("TH\xd4NG B\xc1O"),
                        markReadAll: markReadAll,
                        loading: markAllReadLoading
                    }),
                    notifications.slice(0, 3).map((notification)=>{
                        if (notification) {
                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_desktop_organisms_MiniNotificationItem__WEBPACK_IMPORTED_MODULE_13__/* .MiniNotificationItem */ .f, {
                                title: notification.title,
                                message: notification.message,
                                isRead: notification.is_read,
                                onClick: async ()=>{
                                    onHide && onHide();
                                    await handleNotificationClicked(notification);
                                    if (notification.deepLink) {
                                        router.push(notification.deepLink);
                                    } else if (notification.order) {
                                        router.push({
                                            pathname: "/account/orders/[orderId]",
                                            query: {
                                                orderId: notification.order.orderId
                                            }
                                        }, {
                                            pathname: "/account/orders/".concat(notification.order.orderId)
                                        });
                                    }
                                },
                                time: notification.created_at,
                                avatar: !notification.order ? notification.image_url : notification.order.imageUrl
                            }, notification.id);
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(LastLinkWrapper, _objectSpreadProps(_objectSpread({
                padding: "s8",
                align: "center",
                justify: "center"
            }, (0,_teko_tracking__WEBPACK_IMPORTED_MODULE_14__/* .getTrackingData */ .O)({
                isTrackContent: true,
                regionName: "MiniNotification",
                contentName: "viewNotificationFromMiniNotification",
                target: "Notification"
            })), {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                    href: "/notification",
                    as: "/notification",
                    onClick: onHide,
                    prefetch: false,
                    children: (0,i18n__WEBPACK_IMPORTED_MODULE_9__.t)("Xem tất cả th\xf4ng b\xe1o")
                })
            }))
        ]
    });
};


/***/ }),

/***/ 44304:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "f": function() { return /* binding */ MiniNotificationItem; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(61261);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(91987);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(21483);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(30752);
/* harmony import */ var _teko_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(31439);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    const data = _taggedTemplateLiteral([
        "\n  position: relative;\n  margin-right: 16px;\n  width: 64px;\n  height: 64px;\n  border: 1px solid #e0e0e0;\n  border-radius: 50%;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = _taggedTemplateLiteral([
        "\n  background-color: unset;\n  border-radius: 50%;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = _taggedTemplateLiteral([
        "\n  width: calc(100% - 80px);\n  .message {\n    font-size: 14px;\n    color: #848788;\n    display: -webkit-box;\n    -webkit-box-orient: vertical;\n    -webkit-line-clamp: 2;\n    line-height: 18px;\n    margin-top: 4px;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    width: 100%;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = _taggedTemplateLiteral([
        "\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    const data = _taggedTemplateLiteral([
        "\n  font-size: 13px;\n  font-weight: 500;\n  line-height: 24px;\n  color: #434657;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  overflow: hidden;\n  margin-right: 8px;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    const data = _taggedTemplateLiteral([
        "\n  font-size: 12px;\n  color: #82869e;\n  line-height: 16px;\n  min-width: fit-content;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    const data = _taggedTemplateLiteral([
        "\n  font-size: 13px;\n  color: #82869e;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n  -webkit-line-clamp: 3;\n  line-height: 20px;\n  margin-top: 4px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  width: 100%;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}





const Wrapper = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div */ .Z.div((param)=>{
    let { isRead  } = param;
    return "\n  padding: 16px;\n  display: flex;\n  cursor: pointer;\n  border-bottom: 1px solid #e0e0e0;\n  background-color: ".concat(isRead ? "white" : "rgb(255, 242, 242)", ";\n");
});
const Avatar = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div */ .Z.div(_templateObject());
const ProductImageWrapper = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div */ .Z.div(_templateObject1());
const ContentWrapper = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div */ .Z.div(_templateObject2());
const HeaderWrapper = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div */ .Z.div(_templateObject3());
const TitleWrapper = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__/* ["default"].span */ .Z.span(_templateObject4());
const TimeWrapper = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__/* ["default"].span */ .Z.span(_templateObject5());
const MessageWrapper = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__/* ["default"].span */ .Z.span(_templateObject6());
const MiniNotificationItem = (props)=>{
    const date = new Date(props.time);
    const formatDate = "".concat(date.getDate(), "/").concat(date.getMonth() + 1, " - ").concat(date.getHours(), ":").concat(date.getMinutes());
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(Wrapper, _objectSpreadProps(_objectSpread({
        isRead: props.isRead
    }, props), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Avatar, {
                children: !!props.avatar && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ProductImageWrapper, {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ui__WEBPACK_IMPORTED_MODULE_3__/* .LazyImage */ .w, {
                        src: props.avatar,
                        alt: "",
                        borderRadius: 50,
                        contain: true
                    })
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(ContentWrapper, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(HeaderWrapper, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(TitleWrapper, {
                                children: props.title
                            }),
                            props.time && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(TimeWrapper, {
                                children: formatDate
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(MessageWrapper, {
                        dangerouslySetInnerHTML: {
                            __html: (0,_teko_utils__WEBPACK_IMPORTED_MODULE_4__/* .htmlDecode */ .l)(props.message)
                        }
                    })
                ]
            })
        ]
    }));
};


/***/ }),

/***/ 31439:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "l": function() { return /* binding */ htmlDecode; }
/* harmony export */ });
/* unused harmony export htmlEncode */
const htmlEncode = (html) => {
  return html.replace(/[\u00A0-\u9999<>\&]/g, function(i) {
    return "&#" + i.charCodeAt(0) + ";";
  });
};
const htmlDecode = (str) => {
  const e = document.createElement("textarea");
  e.innerHTML = str;
  if (e.childNodes.length === 0) {
    return "";
  }
  const firstChildNode = e.childNodes[0];
  return firstChildNode.nodeValue;
};




/***/ })

}]);